// extracted by mini-css-extract-plugin
export default {"root":"c6s40Y"};